import { useState } from "react";
import { ErrorMessage, Field } from "formik";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import eyeOpen from "../../assets/icons/eye-line.svg";
import eyeClose from "../../assets/icons/eye-off-line.svg";

const FormPasswordField = ({
  label = "password",
  labelClassName = "",
  name = "password",
  className = "",
  placeholder = "",
  required,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="w-full">
      <Field name={name}>
        {({ field, meta }) => {
          const hasError = meta.touched && meta.error;

          return (
            <div className={`flex flex-col gap-2 ${className} w-full`}>
              {label && (
                <label
                  htmlFor={name}
                  className={`text-sm font-bold tracking-wide uppercase text-slate-700 ${labelClassName} ${
                    hasError ? "text-red-500" : ""
                  }`}
                >
                  {formatUnderscoreToSpace(label)}
                  {required && <span className="text-red-500 ms-0.5">*</span>}
                </label>
              )}

              <div className="relative flex items-center w-full">
                <input
                  {...field}
                  {...props}
                  id={name}
                  name={name}
                  type={showPassword ? "text" : "password"}
                  placeholder={
                    placeholder
                      ? formatUnderscoreToSpace(placeholder)
                      : `Enter ${formatUnderscoreToSpace(label).toLowerCase()}`
                  }
                  required={required}
                  className={`w-full px-4 py-3 text-base text-slate-700 bg-white border rounded-xl transition-all outline-none placeholder:text-slate-400 placeholder:text-base ${
                    hasError
                      ? "border-red-500 focus:border-red-500"
                      : "border-slate-200 focus:border-slate-400"
                  }`}
                />

                <button
                  type="button"
                  tabIndex={-1}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  aria-pressed={showPassword}
                  className="absolute end-3 p-1 rounded-md text-slate-400 hover:text-slate-700 transition-colors active:scale-95 flex items-center justify-center outline-none"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  <img
                    src={showPassword ? eyeOpen : eyeClose}
                    alt={showPassword ? "Hide" : "Show"}
                    width={20}
                    height={20}
                    className="w-5 h-5 opacity-70 hover:opacity-100 transition-opacity"
                  />
                </button>
              </div>

              <div className="min-h-[1.25rem] ps-1">
                <ErrorMessage name={name}>
                  {(msg) => (
                    <span className="text-xs font-medium text-red-500 block">
                      {msg}
                    </span>
                  )}
                </ErrorMessage>
              </div>
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default FormPasswordField;
